import React, { useState, useEffect } from "react";
// import "./Home.css";
import { useNavigate } from "react-router-dom";
export const Home = () => {
  const navigate = useNavigate();

  const slides = [
    {
      title: "Welcome to Health Portal Aggregator Platform",
      desc: "A unified platform integration multiple health programs for seamless health care delivery",
      leftImg: "/images/programs_logo/Element.png",
      rightImg: "/images/programs_logo/pm.png",
    },
    {
      title: "Transform Healthcare Management",
      desc: "Streamline operations with our comprehensive health portal solution for better patient outcomes",
      leftImg: "/images/programs_logo/Element.png",
      rightImg: "/images/programs_logo/jagatprakashnadda_2.jpeg",
    },
    {
      title: "Empowering Healthcare Innovation",
      desc: "Advanced digital solutions for modern healthcare challenges and improved service delivery",
      leftImg: "/images/programs_logo/Element.png",
      rightImg: "/images/programs_logo/pratap.png",
    },
    {
      title: "Healthcare Aggregator Platform",
      desc: "Connecting healthcare providers and patients through innovative technology solutions",
      leftImg: "/images/programs_logo/Element.png",
      rightImg: "/images/programs_logo/apsk.jpg",
    },
  ];
  const faqData = [
    {
      q: "What is the National Health Aggregator Portal?",
      a: "The National Health Aggregator Portal is a centralized digital platform that provides single-window access to multiple national health programs. It enables care providers to manage beneficiary details and view longitudinal health records across integrated disease programs.",
    },
    {
      q: "Who can use the Aggregator Portal?",
      a: "The portal is designed for care providers/program users who are authorized and mapped to one or more integrated health programs (such as NCD, Sickle Cell Disease, Ni-Kshay, UWIN, PMNDP,RCH, etc.).",
    },
    {
      q: "What are the key features of the Aggregator Portal?",
      a: (
        <>
          <p>Key features include:</p>
          <ul className="faq-list">
            <li>Secure login and access control</li>
            <li>Unified access to integrated health programs</li>
            <li>Beneficiary management</li>
            <li>Program-wise data entry</li>
            <li>
              Longitudinal beneficiary record view (timeline, health profile,
              medication history, etc.)
            </li>
          </ul>
        </>
      ),
    },
    {
      q: "How can I log in to the Aggregator Portal?",
      a: (
        <>
          <p>You can log in using either:</p>
          <ul className="faq-list">
            <li>Parichay SSO</li>
            <li>
              Program-specific credentials (Program selection + User ID +
              Password + Captcha)
            </li>
          </ul>
        </>
      ),
    },
    {
      q: "What happens after successful login?",
      a: "After login, the system redirects the user to the Work Plan page where the user can access Dashboard and Settings menus to proceed with configuration and beneficiary management. ",
    },
  ];
  const [active, setActive] = useState(0);
  const [slideIndex, setSlideIndex] = useState(0);

  // Auto-slide
  useEffect(() => {
    const interval = setInterval(() => {
      setSlideIndex((prev) => (prev + 1) % slides.length);
    }, 50000);
    return () => clearInterval(interval);
  }, [slides.length]);

  // Manual navigation
  const changeSlide = (n) => {
    setSlideIndex((prev) => {
      let newIndex = prev + n;
      if (newIndex >= slides.length) newIndex = 0;
      if (newIndex < 0) newIndex = slides.length - 1;
      return newIndex;
    });
  };

  const currentSlide = (n) => setSlideIndex(n);

  return (
    <div>
      <section className="headerSection">
        <div className="container">
          <div className="headerRow">
            {/* LEFT LOGO */}
            <div className="headerLeft">
              <img
                src="/images/programs_logo/NHM-black.png"
                alt="NHM"
                className="nhmLogo"
              />
              <span className="portalTitle">Unified Health Portal</span>
            </div>

            {/* CENTER LOGO */}
            <div className="headerCenter">
              <img
                src="/images/programs_logo/ashoka.svg"
                alt="Govt of India"
                className="govLogo"
              />
              {/* <p>
          Ministry of Health and Family Welfare<br />
          Government of India
        </p> */}
            </div>

            {/* RIGHT LOGO + LOGIN */}
            <div className="headerRight">
              {/* <img
                src="/images/programs_logo/nhsrc.png"
                alt="NHSRC"
                className="nhsrcLogo"
              /> */}
              <button onClick={() => navigate("/login")} className="loginBtn">
                Login
              </button>
            </div>
          </div>
        </div>
      </section>
      <section className="banner">
        {/* Left top dots */}
        <div className="left-dot dotsLeftTop"></div>

        {/* Right side dots */}
        <div className="dots dotsRight"></div>
        <div className="rightBgImage"></div>
        <div className="container">
          <div className="bannerContent">
            <h1>
              Welcome to Health <br />
              Portal Aggregator <br />
              Platform
            </h1>

            <p>
              A unified platform integration multiple health programs for
              seamless health care delivery
            </p>

            <button onClick={() => navigate("/login")}>Get Started</button>
          </div>
        </div>
      </section>

      <section className="healthProgram">
        <div className="container">
          <h5 className="integrateHelthProgramTitle">
            Integrated Health Programs
          </h5>

          <div className="row">
            {/* NCD */}
            <div className="col-md-4 col-sm-6">
              <div className="programCard">
                <div className="programHeader">
                  <img src="/images/NCD.svg" alt="NCD" />
                  <h5>NCD</h5>
                </div>
                <div className="programBody">
                  <p>
                    In order to prevent and control major NCDs, Government of India has implemented the National Programme for Prevention and Control of Cancer, Diabetes, Cardiovascular Diseases and Stroke (NPCDCS) in all States across the country with the focus on strengthening of infrastructure, development of human resource, emphasis on health promotion, population based screening (age 30 years & above) early diagnosis, management and referral.
                  </p>
                  {/* <a
                    href="https://www.ncd-test.mohfw.gov.in/ncdlandingassets/aboutus.html"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Read more..
                  </a> */}
                </div>
              </div>
            </div>

            {/* Sickle Cell */}
            <div className="col-md-4 col-sm-6">
              <div className="programCard">
                <div className="programHeader">
                  <img src="/images/Sickel.svg" alt="Sickle Cell" />
                  <h5>Sickle Cell Diseases</h5>
                </div>
                <div className="programBody">
                  <p>
                    Sickle cell disease is a genetic blood disease which affects the whole life of affected patient. It is more common in the tribal population of India, but occurs in non tribals too. It not only causes anemia but also pain crises, reduced growth, and affects many organs like lungs, heart, kidney, eyes, bones and the brain. Ministry of health under NHM initiated the work on hemoglobinopathies (Thalassemia & Sickle Cell Disease) in 2016 wherein comprehensive guidelines on prevention and management of heamoglobinopathies were released and provision of funds towards screening and management of Sickle cell disease were made. 
                  </p>
                  {/* <a
                    href="https://sickle.nhm.gov.in/home/about"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Read more..
                  </a> */}
                </div>
              </div>
            </div>

            {/* U-WIN */}
            <div className="col-md-4 col-sm-6">
              <div className="programCard">
                <div className="programHeader">
                  <img src="/images/uwin.svg" alt="U-Win" />
                  <h5>U-Win</h5>
                </div>
                <div className="programBody">
                  <p>
                   India’s Universal Immunization Programme (UIP) is a part of the Reproductive and Child Health (RCH) Program under National Health Mission (NHM). It is one of the largest public health programs in the world under which vaccination is being provided free of cost to all pregnant women & children. Vaccination can be availed against 12 vaccine preventable diseases: nationally against 11 diseases- Diphtheria, Pertussis, Tetanus, Polio, Measles, Rubella, severe form of childhood Tuberculosis, Rotavirus Diarrhoea, Hepatitis B, Meningitis & Pneumonia caused by Hemophilus Influenza Type B and Pneumococcal Pneumonia and sub-nationally against 1 Disease - Japanese Encephalitis (JE vaccine is provided only in endemic districts). 
                  </p>
                  {/* <a
                    href="https://uwin.mohfw.gov.in/home"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Read more..
                  </a> */}
                </div>
              </div>
            </div>
            {/* ===Nikshay==== */}
            <div className="col-md-4 col-sm-6 mt-3">
              <div className="programCard">
                <div className="programHeader">
                  <img src="/images/Ni-kshay.svg" alt="Ni-kshay" />
                  <h5>Ni-Kshay</h5>
                </div>
                <div className="programBody">
                  <p>
                    NI-KSHAY-(Ni=End, Kshay=TB) is the web enabled patient management system for TB control under the National Tuberculosis Elimination Programme (NTEP). It is developed and maintained by the Central TB Division (CTD), Ministry of Health and Family Welfare, Government of India, in collaboration with the National Informatics Centre (NIC), and the World Health Organization Country office for India. 

Ni-kshay is used by health functionaries at various levels across the country both in the public and private sector, to register cases under their care, order various types of tests from Labs across the country, record treatment details, monitor treatment adherence and to transfer cases between care providers. It also functions as the National TB Surveillance System and enables reporting of various surveillance data to the Government of India. 
                  </p>
                  {/* <a href="https://www.nikshay.in/Home/AboutUs" target="_blank">
                    Read more..
                  </a> */}
                </div>
              </div>
            </div>
            {/* =====PMNDP=== */}
            <div className="col-md-4 col-sm-6 mt-3">
              <div className="programCard">
                <div className="programHeader">
                  <img
                    src="/images/programs_logo/program/PMNDP5.svg"
                    alt="PMNDP"
                  />
                  <h5>PMNDP</h5>
                </div>
                <div className="programBody">
                  <p>
                    Every year, about 2.2lakh new patients of End-Stage Renal Disease (ESRD) get added in India resulting in additional demand for 3.4 Crore dialysis every year. The high cost of dialysis care leads to financial catastrophe for practically all families with such patients. 

Towards this, Ministry of Health & Family Welfare launched the ‘Pradhan Mantri National Dialysis Program’ (PMNDP) under the National Health Mission in Public Private Partnership (PPP) mode in Union Budget 2016-17 at all the District Hospitals, to make renal-care services accessible & affordable to BPL (Below Poverty Line) patients. 
                  </p>
                  {/* <a href="https://pmndp.mohfw.gov.in" target="_blank">
                    Read more..
                  </a> */}
                </div>
              </div>
            </div>
            {/* ===ABDM==== */}
            <div className="col-md-4 col-sm-6 mt-3">
              <div className="programCard">
                <div className="programHeader">
                  <img
                    src="/images/programs_logo/program/RCHicons.svg"
                    alt="RCH"
                  />
                  <h5>RCH</h5>
                </div>
                <div className="programBody">
                  <p>
                     RCH Portal is designed for early identification and tracking of the individual beneficiary throughout the reproductive lifecycle of women and promote, monitor and support the reproductive, maternal, new-born, child health schemes delivery and reporting. 
                  </p>
                  {/* <a href="https://abdm.gov.in/abdm" target="_blank">
                    Read more..
                  </a> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="abdmSection">
        <div className="container">
          <h2 className="abdmTitle">ABDM Component Supported In Aggregator</h2>

          <div className="abdmGrid">
            {/* ABHA NUMBER */}
            <div className="flipCard">
              <div className="flipInner">
                <div className="flipFront">
                  <img src="/images/Abhacard.svg" alt="HFR" />
                  <h5>ABHA Number</h5>
                  <div className="cardActions">
                    {/* <button className="knowBtn frontbtn"  onClick={() =>
                        window.open(
                          "https://abdm.gov.in/",
                          "_blank"
                        )
                      }>Know More</button> */}
                    <button
                      className="videoBtnn videofront"
                      onClick={() =>
                        window.open(
                          "https://www.youtube.com/watch?v=dw6qSD8AaxQ",
                          "_blank"
                        )
                      }
                    >
                      ▶
                    </button>
                  </div>
                </div>

                <div className="flipBack">
                  <h5>ABHA Number</h5>
                  <p>
                    ABHA enables secure digital health identity, access to
                    prescriptions, lab reports and diagnosis from verified
                    healthcare providers across India.
                  </p>

                  <div className="cardActions backside_card">
                    {/* <button className="knowBtn"   onClick={() =>
                        window.open(
                          "https://abdm.gov.in/",
                          "_blank"
                        )
                      }>Know More</button> */}
                    <button
                      className="videoBtn videoback"
                      onClick={() =>
                        window.open(
                          "https://www.youtube.com/watch?v=dw6qSD8AaxQ",
                          "_blank"
                        )
                      }
                    >
                      ▶
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* HEALTH FACILITY REGISTRY */}
            <div className="flipCard">
              <div className="flipInner">
                <div className="flipFront">
                  <img src="/images/Helthfaclity.svg" alt="HFR" />
                  <h5>Health Facility Registry</h5>
                  <div className="cardActions">
                    <button
                      className="knowBtn frontbtn"
                      onClick={() =>
                        window.open(
                          "https://nhpr.abdm.gov.in/nhpr/v4/home",
                          "_blank"
                        )
                      }
                    >
                      Know More
                    </button>
                    <button
                      className="videoBtnn videofront"
                      onClick={() =>
                        window.open(
                          "https://www.youtube.com/watch?v=bhjb_HHB8Ik",
                          "_blank"
                        )
                      }
                    >
                      ▶
                    </button>
                  </div>
                </div>

                <div className="flipBack">
                  <h5>Health Facility Registry</h5>
                  <p>
                    HFR is a national repository of verified health facilities
                    enabling standardized identification and trust across the
                    digital health ecosystem.
                  </p>

                  <div className="cardActions backside_card">
                    <button
                      className="knowBtn"
                      onClick={() =>
                        window.open(
                          "https://nhpr.abdm.gov.in/nhpr/v4/home",
                          "_blank"
                        )
                      }
                    >
                      Know More
                    </button>
                    <button
                      className="videoBtn videoback"
                      onClick={() =>
                        window.open(
                          "https://www.youtube.com/watch?v=bhjb_HHB8Ik",
                          "_blank"
                        )
                      }
                    >
                      ▶
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* HEALTHCARE PROFESSIONALS REGISTRY */}
            <div className="flipCard">
              <div className="flipInner">
                <div className="flipFront">
                  <img src="/images/HPR.svg" alt="HPR" />
                  <h5>Healthcare Professionals Registry</h5>
                  <div className="cardActions">
                    <button className="knowBtn frontbtn" onClick={() =>
                        window.open(
                          "https://nhpr.abdm.gov.in/nhpr/v4/home",
                          "_blank"
                        )
                      }>Know More</button>
                    <button className="videoBtnn videofront" onClick={() =>
                        window.open(
                          "https://www.youtube.com/watch?v=PAIGX5n290c",
                          "_blank"
                        )
                      }>▶</button>
                  </div>
                </div>

                <div className="flipBack">
                  <h5>Healthcare Professionals Registry</h5>
                  <p>
                    HPR maintains a centralized verified database of healthcare
                    professionals, improving trust and interoperability in
                    healthcare delivery.
                  </p>

                  <div className="cardActions backside_card">
                    <button className="knowBtn" onClick={() =>
                        window.open(
                          "https://nhpr.abdm.gov.in/nhpr/v4/home",
                          "_blank"
                        )}>Know More</button>
                    <button className="videoBtn videoback"  onClick={() =>
                        window.open(
                          "https://www.youtube.com/watch?v=PAIGX5n290c",
                          "_blank"
                        )
                      }>▶</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="keyFeatures">
        <div className="container">
          <div className="keyFeaturesTitle">
            <h4>Key Features</h4>
          </div>
          <div className="row">
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-3 col-xl-3">
              <div className="featuresColum">
                <div className="iconSection">
                  <img src={"/images/programs_logo/features/features-1.png"} />
                </div>
                <h4>Unified Health Access</h4>
                <p>
                  Single unified interface for accessing multiple health
                  programs and services
                </p>
              </div>
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-3 col-xl-3">
              <div className="featuresColum">
                <div className="iconSection">
                  <img src={"/images/programs_logo/features/features-2.png"} />
                </div>
                <h4>Smart Decisions</h4>
                <p>
                  Data driven insights and analytics for informed decision
                  making
                </p>
              </div>
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-3 col-xl-3">
              <div className="featuresColum">
                <div className="iconSection">
                  <img src={"/images/programs_logo/features/features-3.png"} />
                </div>
                <h4>No Duplicate Entry</h4>
                <p>
                  Eliminate redundant data entry across different health systems
                </p>
              </div>
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-3 col-xl-3">
              <div className="featuresColum">
                <div className="iconSection">
                  <img src={"/images/programs_logo/features/features-4.png"} />
                </div>
                <h4>Minimum Rework</h4>
                <p>
                  Streamlined processes to minimize repetitive tasks and improve
                  efficiency
                </p>
              </div>
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-3 col-xl-3">
              <div className="featuresColum">
                <div className="iconSection">
                  <img src={"/images/programs_logo/features/features-5.png"} />
                </div>
                <h4>Enhanced Patient Care</h4>
                <p>
                  Enhanced healthcare services and improved patient experience
                </p>
              </div>
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-3 col-xl-3">
              <div className="featuresColum">
                <div className="iconSection">
                  <img src={"/images/programs_logo/features/features-6.png"} />
                </div>
                <h4>Real Time Analytics</h4>
                <p>Comprehensive reporting and data visualization</p>
              </div>
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-3 col-xl-3">
              <div className="featuresColum">
                <div className="iconSection">
                  <img src={"/images/programs_logo/features/features-7.png"} />
                </div>
                <h4>Secure Access</h4>
                <p>Role-based authentication and data security</p>
              </div>
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-3 col-xl-3">
              <div className="featuresColum">
                <div className="iconSection">
                  <img src={"/images/programs_logo/features/features-8.png"} />
                </div>
                <h4>Mobile Responsive</h4>
                <p>Access from any device, anywhere</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="integration-section">
        <div className="container">
          <div className="circle-wrapper">
            <div className="logos left-group" aria-label="Left logos">
              <div className="logo ">
                <img src={"/images/ncd.svg"} alt="Logo 1" />
              </div>
              <div className="logo ">
                <img
                  src={"/images/programs_logo/program/RCHicons.svg"}
                  alt="Logo 2"
                />
              </div>
              <div className="logo logo3">
                <img src={"/images/Sickel.svg"} alt="Logo 3" />
              </div>
            </div>
            <div className="logos right-group" aria-label="Right logos">
              <div className="logo logo4">
                <img
                  src={"/images/programs_logo/program/nikshay.png"}
                  alt="Logo 4"
                />
              </div>
              <div className="logo logo5">
                <img
                  src={"/images/programs_logo/program/PMNDP5.svg"}
                  alt="Logo 5"
                />
              </div>
              <div className="logo logo6">
                <img
                  src={"/images/programs_logo/program/u-win.png"}
                  alt="Logo 6"
                />
              </div>
            </div>
            <div className="center-text">
              <div className="label">Integration</div>
              <h1 className="headline">
                Seamless integrations with <br />
                other Health Portals
              </h1>
            </div>
          </div>
        </div>
      </section>
      <section className="faqSection">
        <div className="container">
          <h2 className="faqTitle">Frequently Asked Questions</h2>

          <div className="faqList">
            {faqData.map((item, i) => (
              <div
                key={i}
                className={`faqItem ${active === i ? "active" : ""}`}
                onClick={() => setActive(active === i ? null : i)}
              >
                <div className="faqQuestion">
                  <span>{item.q}</span>
                  <span className="icon">{active === i ? "−" : "+"}</span>
                </div>

                <div className="faqAnswer">
                  <p>{item.a}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="footer">
        <div className="container">
          <p>
            © All right reserved by Ministry of Health & Family Welfare,
            Government Of India.
          </p>
        </div>
      </section>
    </div>
  );
};
